import { render, staticRenderFns } from "./indexTypeAdd.vue?vue&type=template&id=29725b08&scoped=true&"
import script from "./indexTypeAdd.vue?vue&type=script&lang=js&"
export * from "./indexTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29725b08",
  null
  
)

export default component.exports